import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import * as fromProfile from 'app/reducers/profile';

export const hasAnyLicenseGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const store: Store = inject(Store);
  const router: Router = inject(Router);

  return store.select(fromProfile.selectHasAnyLicenseNullable).pipe(
    take(1),
    map((hasAnyLicense: boolean) => {
      if (hasAnyLicense === null) {
        return true;
      }
      return hasAnyLicense || router.createUrlTree(['/licenses'])
    })
  );
};
